<template>
  <div>
    Favor acessar o SSO
    <!-- <Login /> -->
  </div>
</template>

<script>
// import Login from '../components/Login/Login'

export default {
  // components: { Login }
}
</script>
